import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import AddStaffForm from "../AddStaffForm";
import StaffListTable from "../../components/StaffListTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { resetSelectedStaff, setIsUpdatedStaff, setStaffDetails } from "../../redux/reducers/dataCaptures";
import { getStaffDetails, saveStaffDetails } from "../../api/dataCapture";
import StaffRoleTable from "../../components/StaffRoleTable";
import './styles.css';
import { useTranslation } from "react-i18next";
import StaffDetailPage from "../StaffDetailPage";

const StafffDetails = () => {
    const [addNewStaff, setAddNewStaff] = React.useState(false);
    const dispatch = useDispatch();
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const [t] = useTranslation();
    const selectedStaff = useSelector((state:any) => state.dataCaptures.selectedStaff);
    const isUpdatedStaff = useSelector((state:any) => state.dataCaptures.isUpdatedStaff);
    const data = useSelector((state:any) => state.dataCaptures.staffDetails);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    
    useEffect(() => {
        const fetchStaffDetails = async () => {
            const response = await getStaffDetails({clubId: clubDetails.id, isPast: false});
            dispatch(setStaffDetails(response));
        }
        fetchStaffDetails();
    }, []);
    
    const manageCloseStaffDetails = () => {
    if (isUpdatedStaff) {
        const updatedList = data?.map((item:any) => item?.id == selectedStaff?.id ? selectedStaff : item);
        const response = saveStaffDetails({clubId: clubDetails?.id, data: updatedList});
        dispatch(setStaffDetails(response));
        const boolean:any = false;
        dispatch(setIsUpdatedStaff(boolean));
    }
    dispatch(resetSelectedStaff());
    }

    const createNewStaff = (newStaff:any) => {
        const updatedData = [...data, newStaff];
        saveStaffDetails({clubId: clubDetails?.id, data: updatedData})
        .then((res:any) => {
        dispatch(setStaffDetails(res));
        });
        setAddNewStaff(false);
    }

    return (
        <Box className='liceDataSubContainer'>
            {addNewStaff && <AddStaffForm onCancelClick={() => setAddNewStaff(false)} onAddClick={createNewStaff}/>}
            <StaffDetailPage isOpen={selectedStaff && Object.keys(selectedStaff).length > 0} 
              handleClose={manageCloseStaffDetails} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography className='standardsHeading uppercase'>Staff list</Typography>
                {
                    !isAdmin &&
                    <Button className='smallButton' 
                    sx={{ float: 'right' }} 
                    disableElevation 
                    disabled={addNewStaff} 
                    variant='contained' 
                    size='small' 
                    onClick={() => {setAddNewStaff(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                        {'Add staff member'}
                    </Button>
                }
            </Box>
            <StaffListTable />
            <Box className='liceDataSubContainer'>
                <Typography className='standardsHeading uppercase'>{'Staff Roles'}</Typography>
                <Box>
                    <StaffRoleTable />
                </Box>
            </Box>
        </Box>
    )
}

export default StafffDetails;